$(document).ready(function(){
  $("input[name=public_honorroll]").click(function(){
    if($(this).prop('checked')===true){
      $(".public-honorroll-wrap").css('display', 'block');
    }
    if ($(this).prop('checked')===false){
      $(".public-honorroll-wrap").css('display', 'none');
    }
  });
  $("input[name=show_name_note]").click(function(){
    if($(this).val()== "true"){
      $('.order-note-wrap').css('display','block');
    }
    if($(this).val()== "false"){
      $('.order-note-wrap').css('display','none');
    }
  });

});
